import { http } from "../http/Http";
import { ProcessInstance } from "../models/ProcessInstance";
import { ProcessInstanceRuntime } from "../models/ProcessInstanceRuntime";
import { ServiceResponse } from "../models/ServiceResponse";
import { GetByFiltersArguments } from "../models/GetByFiltersArguments";

export class ProcessInstanceService {

    getProcessInstancesByFilters = async (apiQueryFilter: GetByFiltersArguments): Promise<ServiceResponse<ProcessInstance[]>> => {
        const { data } = await http.post<ServiceResponse<ProcessInstance[]>>("ProcessInstance/GetByFilters", apiQueryFilter);
        return data;
    };

    getProcessInstance = async (id: string): Promise<ProcessInstanceRuntime> => {
        const { data } = await http.get<ProcessInstanceRuntime>(("ProcessInstance/GetById/" + id));
        return data;
    };

}